
<template>
  <div
    v-show="activeRoomId != '' && roomDetail.title != ''"
    class="col-lg-3 message-view chat-profile-view chat-sidebar waajo-contact-panel"
    id="task_window"
  >
    <div class="waajo-panel-inner">
      <div class="waajo-panel-head">
        <div class="waajo-panel-avatar">
          <img
            src="@/assets/profiles/avatar-02.jpg"
            alt
            v-if="roomDetail.room_photo == ''"
          />
          <img v-lazy="roomDetail.room_photo" alt v-else />
        </div>
        <h4>{{ roomDetail.room_title }}</h4>
        <span class="waajo-panel-channel">
          <i :class="roomDetail.is_group == 1 ? 'fa fa-users' : 'fa fa-whatsapp'"></i>
          {{ roomDetail.is_group == 1 ? "Grup WhatsApp" : "Kontak WhatsApp" }}
        </span>
      </div>

      <div class="waajo-panel-actions">
        <button
          type="button"
          class="waajo-panel-action"
          @click="$root.$emit('openDirectChat')"
        >
          <span><i class="fa fa-comments-o"></i></span>
          <strong>Chat Langsung</strong>
        </button>
        <button
          type="button"
          class="waajo-panel-action"
          @click="$root.$emit('openAddContact', roomDetail)"
        >
          <span><i class="fa fa-user-plus"></i></span>
          <strong>Tambah Kontak</strong>
        </button>
      </div>

      <div class="waajo-panel-section">
        <h6>Informasi Kontak</h6>

        <div v-if="roomDetail.is_group == 0" class="waajo-panel-row">
          <span>Nomor WhatsApp</span>
          <strong>{{ displayPhoneNumber }}</strong>
        </div>

        <div class="waajo-panel-row">
          <span>Jenis Percakapan</span>
          <strong>{{ roomDetail.is_group == 1 ? "Grup" : "Pribadi" }}</strong>
        </div>

        <p v-if="phoneChangedInActiveRoom" class="waajo-panel-note">
          <i class="fa fa-info-circle"></i>
          Percakapan aktif tetap menggunakan nomor lama.
        </p>

        <button
          v-if="roomDetail.is_group == 0"
          type="button"
          class="waajo-panel-edit"
          :disabled="!canEditContact"
          :title="canEditContact ? 'Edit kontak' : 'Data kontak belum tersedia'"
          @click="openEditContact"
        >
          <i class="fa fa-pencil"></i>
          Edit Kontak
        </button>
      </div>

      <div
        v-if="roomDetail.is_group != 1"
        class="waajo-panel-section waajo-ai-session-section"
      >
        <div class="waajo-ai-session-head">
          <h6>
            <i class="fa fa-android"></i>
            AI Chat
          </h6>
          <span class="waajo-ai-session-head-right">
            <i
              v-if="aiSessionRefreshing"
              class="fa fa-spinner fa-spin waajo-ai-session-refreshing"
              title="Memperbarui status AI"
            ></i>
            <span
              v-if="aiSession && !aiSessionLoading"
              class="waajo-ai-session-badge"
              :class="aiSessionBadgeClass"
            >
              {{ aiSessionBadgeLabel }}
            </span>
          </span>
        </div>

        <div v-if="aiSessionLoading" class="waajo-ai-session-card">
          <span class="waajo-ai-session-skeleton is-line"></span>
          <span class="waajo-ai-session-skeleton is-line is-short"></span>
          <span class="waajo-ai-session-skeleton is-button"></span>
        </div>

        <div v-else-if="!aiSession" class="waajo-ai-session-card">
          <div v-if="aiSessionError" class="waajo-ai-session-error">
            <i class="fa fa-exclamation-circle"></i>
            <span>{{ aiSessionError }}</span>
            <button type="button" @click="refreshAiSession()">Coba lagi</button>
          </div>
          <div v-else class="waajo-ai-session-empty">
            <i class="fa fa-comments-o"></i>
            <span>Tidak ada sesi AI untuk percakapan ini.</span>
          </div>
        </div>

        <div
          v-else
          class="waajo-ai-session-card"
          :class="'is-' + aiSessionStatus"
        >
          <div class="waajo-ai-session-state">
            <span class="waajo-ai-session-icon">
              <i :class="aiSessionIcon"></i>
            </span>
            <div class="waajo-ai-session-copy">
              <strong>{{ aiSessionTitle }}</strong>
              <p>{{ aiSessionDescription }}</p>
            </div>
          </div>

          <button
            v-if="aiSessionStatus === 'running' && aiSessionHasId"
            type="button"
            class="waajo-ai-session-action is-pause"
            :disabled="aiActionLoading"
            @click="pauseAiSession"
          >
            <i :class="aiActionLoading ? 'fa fa-spinner fa-spin' : 'fa fa-pause'"></i>
            {{ aiActionLoading ? "Memproses..." : "Jeda AI" }}
          </button>

          <button
            v-else-if="aiSessionStatus === 'paused' && aiSessionHasId"
            type="button"
            class="waajo-ai-session-action is-resume"
            :disabled="aiActionLoading"
            @click="resumeAiSession"
          >
            <i :class="aiActionLoading ? 'fa fa-spinner fa-spin' : 'fa fa-play'"></i>
            {{ aiActionLoading ? "Memproses..." : "Aktifkan Kembali AI" }}
          </button>

          <div
            v-if="!aiSessionHasId && (aiSessionStatus === 'running' || aiSessionStatus === 'paused')"
            class="waajo-ai-session-error is-inline"
          >
            <i class="fa fa-exclamation-circle"></i>
            <span>ID sesi AI tidak ditemukan. Kontrol tidak tersedia.</span>
          </div>

          <div v-if="aiSessionError" class="waajo-ai-session-error is-inline">
            <i class="fa fa-exclamation-circle"></i>
            <span>{{ aiSessionError }}</span>
          </div>

          <small v-if="aiSessionMeta" class="waajo-ai-session-meta">
            {{ aiSessionMeta }}
          </small>
        </div>
      </div>

      <div
        v-if="roomDetail.is_group != 1"
        class="waajo-panel-section waajo-ticket-section"
      >
        <div class="waajo-ticket-head">
          <h6>
            <i class="fa fa-ticket"></i>
            Ticket
          </h6>
          <span class="waajo-ticket-head-actions">
            <i
              v-if="ticketRefreshing"
              class="fa fa-spinner fa-spin waajo-ticket-refreshing"
              title="Memperbarui tiket"
            ></i>
            <button
              type="button"
              class="waajo-ticket-refresh-btn"
              :disabled="ticketLoading || ticketRefreshing"
              title="Muat ulang tiket"
              @click="refreshTickets({ force: true })"
            >
              <i class="fa fa-refresh"></i>
            </button>
            <button
              type="button"
              class="waajo-ticket-add-btn"
              :disabled="ticketLoading"
              @click="openTicketModal"
            >
              <i class="fa fa-plus"></i> Buat
            </button>
          </span>
        </div>

        <div v-if="ticketLoading" class="waajo-ticket-card">
          <span class="waajo-ticket-skeleton"></span>
          <span class="waajo-ticket-skeleton is-short"></span>
          <span class="waajo-ticket-skeleton is-button"></span>
        </div>

        <div v-else-if="ticketError && !ticketRows.length" class="waajo-ticket-card">
          <div class="waajo-ticket-error">
            <i class="fa fa-exclamation-circle"></i>
            <span>{{ ticketError }}</span>
            <button type="button" @click="refreshTickets({ force: true })">Coba lagi</button>
          </div>
        </div>

        <div v-else-if="!ticketRows.length" class="waajo-ticket-card">
          <div class="waajo-ticket-empty">
            <i class="fa fa-ticket"></i>
            <span>Belum ada tiket untuk percakapan ini.</span>
          </div>
          <button type="button" class="waajo-ticket-create-btn" @click="openTicketModal">
            <i class="fa fa-plus"></i> Buat Tiket
          </button>
        </div>

        <div v-else class="waajo-ticket-card">
          <div v-if="ticketError" class="waajo-ticket-error is-inline">
            <i class="fa fa-exclamation-circle"></i>
            <span>{{ ticketError }}</span>
            <button type="button" @click="refreshTickets({ force: true })">Coba lagi</button>
          </div>
          <div class="waajo-ticket-list">
            <div v-for="ticket in ticketRows" :key="ticket.id" class="waajo-ticket-item">
              <div class="waajo-ticket-item-top">
                <span class="waajo-ticket-number">{{ ticket.ticket_number }}</span>
                <span
                  class="waajo-ticket-badge"
                  :class="'is-status-' + String(ticket.status || 'open').replace('_', '-')"
                >{{ ticketStatusLabel(ticket.status) }}</span>
              </div>
              <strong class="waajo-ticket-title">{{ ticket.title }}</strong>
              <div class="waajo-ticket-meta">
                <span
                  class="waajo-ticket-badge"
                  :class="'is-priority-' + (ticket.priority || 'normal')"
                >{{ ticketPriorityLabel(ticket.priority) }}</span>
                <span class="waajo-ticket-pic">
                  {{ ticket.assigned_agent_name || "Belum ada PIC" }}
                </span>
              </div>
              <div class="waajo-ticket-item-foot">
                <small>{{ formatTicketDate(ticket.create_datetime) }}</small>
                <button type="button" class="waajo-ticket-detail-btn" @click="goTicketDetail(ticket)">
                  Detail <i class="fa fa-angle-right"></i>
                </button>
              </div>
            </div>
          </div>
          <button type="button" class="waajo-ticket-create-btn" @click="openTicketModal">
            <i class="fa fa-plus"></i> Buat Tiket dari Chat
          </button>
        </div>
      </div>

      <div class="waajo-panel-section">
        <h6>Label Kontak</h6>
        <tags-assign
          ref="tagsAssign"
          :getWhatsappNumberFromJid="getWhatsappNumberFromJid"
          :roomDetail="roomDetail"
          @contact-resolved="handleContactResolved"
        />
      </div>

      <div class="waajo-panel-section">
        <div class="waajo-panel-section-head">
          <h6>Berkas Dibagikan</h6>
          <span>{{ groupMessageMediaFile.length + groupMessageMedia.length }}</span>
        </div>

        <ul v-if="groupMessageMediaFile.length || groupMessageMedia.length" class="waajo-file-list">
          <li
            v-for="row in groupMessageMediaFile"
            :key="'file-' + row.message_media"
          >
            <a :href="row.message_media" target="_blank" class="waajo-file-icon">
              <i :class="row.message_type === 'video' ? 'fa fa-film' : 'fa fa-file'"></i>
            </a>
            <div class="waajo-file-info">
              <strong>{{ fileNameFromUrl(row.message_media) }}</strong>
              <small>{{ row.timeISODatetime }}</small>
            </div>
            <button
              type="button"
              class="waajo-file-action"
              title="Unduh berkas"
              @click.prevent="downloadItem(row.message_media, fileNameFromUrl(row.message_media))"
            >
              <i class="fa fa-download"></i>
            </button>
          </li>

          <li v-for="(row, index) in groupMessageMedia" :key="'media-' + index">
            <a
              href="javascript:void(0)"
              class="waajo-file-icon is-image"
              v-if="row.message_type == 'image'"
              @click.prevent="clickLightBox(row.message_media)"
            >
              <img :src="row.message_media" alt="" loading="lazy" />
            </a>
            <a
              v-else
              :href="row.message_media"
              target="_blank"
              class="waajo-file-icon"
            >
              <i class="fa fa-file"></i>
            </a>
            <div class="waajo-file-info">
              <strong>
                {{ row.from_me == 1 ? "Anda" : row.message_name || "Kontak" }}
              </strong>
              <small>{{ row.timeISODatetime }}</small>
            </div>
            <button
              type="button"
              class="waajo-file-action"
              title="Unduh berkas"
              @click.prevent="downloadItem(row.message_media, row.message_name)"
            >
              <i class="fa fa-download"></i>
            </button>
          </li>
        </ul>

        <div v-else class="waajo-panel-empty">
          Belum ada berkas yang dibagikan.
        </div>
      </div>
    </div>

    <contact-form-modal-v2
      :visible="showEditContact"
      mode="edit"
      :contact-id="contactId"
      @close="showEditContact = false"
      @saved="handleContactSaved"
    />

    <ticket-create-modal
      :visible="showTicketModal"
      :context="ticketContext || {}"
      @close="showTicketModal = false"
      @created="handleTicketCreated"
      @completed="handleTicketAttachmentsUploaded"
      @open-detail="handleOpenTicketDetail"
    />
  </div>
</template>
<script>
import axios from "axios";
import moment from "moment";
import { mapGetters } from "vuex";
import { getWhatsappNumberFromJid } from "@/utils/helper";
import TagsAssign from "./components/tagsAssign.vue";
import ContactFormModalV2 from "@/views/contacts/ContactFormModalV2.vue";
import TicketCreateModal from "@/views/ticket/components/TicketCreateModal.vue";
import {
  ticketStatusLabel,
  ticketPriorityLabel,
  formatTicketDate
} from "@/utils/ticket";

export default {
  components: {
    TagsAssign,
    ContactFormModalV2,
    TicketCreateModal
  },
  data() {
    return {
      roomDetail: {
        room_title: "",
        provider: "",
        room_photo: "",
        update_datetime: 0,
        room_number: 0,
        is_group: 0
      },
      contactId: "",
      contactPhoneNumber: "",
      phoneChangedInActiveRoom: false,
      showEditContact: false,
      editRoomId: "",
      aiSession: null,
      aiSessionLoading: false,
      aiSessionRefreshing: false,
      aiSessionError: "",
      aiSessionRequestId: 0,
      aiSessionRoomId: "",
      aiSessionContextRoomId: "",
      aiActionLoading: false,
      aiRefreshTimer: null,
      aiPollTimer: null,
      ticketRows: [],
      ticketLoading: false,
      ticketRefreshing: false,
      ticketError: "",
      ticketRequestId: 0,
      ticketLastRoomId: "",
      ticketRefreshTimer: null,
      ticketPollTimer: null,
      showTicketModal: false,
      ticketContext: null
    };
  },
  watch: {
    activeRoomId: {
      handler: function(val, oldVal) {
        if (!val && !oldVal) {
          return;
        }
        if (String(val || "") === String(oldVal || "")) {
          return;
        }
        this.resetAiSessionState(val);
        this.scheduleAiSessionRefresh(0, false);
        this.resetTicketState(val);
        this.scheduleTicketRefresh(0, false);
      },
      immediate: true
    },
    agentSession: {
      handler: function(val, oldVal) {
        const nextLicense = val && val.license_id ? String(val.license_id) : "";
        const previousLicense =
          oldVal && oldVal.license_id ? String(oldVal.license_id) : "";
        const nextPhone =
          val && val.license_phone_number
            ? this.normalizeAiPhone(val.license_phone_number)
            : "";
        const previousPhone =
          oldVal && oldVal.license_phone_number
            ? this.normalizeAiPhone(oldVal.license_phone_number)
            : "";
        if (
          nextLicense !== previousLicense ||
          nextPhone !== previousPhone
        ) {
          this.resetAiSessionState(this.activeRoomId);
          this.scheduleAiSessionRefresh(0, false);
          this.resetTicketState(this.activeRoomId);
          this.scheduleTicketRefresh(0, false);
        }
      },
      deep: true
    },
    NEW_UNREAD_MESSAGE_ROOM_Data: {
      handler: function() {
        this.scheduleAiSessionRefresh(500, true);
      },
      deep: true
    },
    RefreshRoomChatData: {
      handler: function(val) {
        if (val) {
          this.scheduleAiSessionRefresh(500, true);
        }
      },
      deep: true
    }
  },
  computed: {
    ...mapGetters([
      "activeRoomId",
      "getRoomById",
      "agentSession",
      "NEW_UNREAD_MESSAGE_ROOM_Data"
    ]),
    RefreshRoomChatData() {
      return this.$store.state.pusher.RefreshRoomChatData;
    },
    groupMessageMedia() {
      return this.$store.state.omniroom.groupMessageMedia.slice().reverse();
    },
    groupMessageMediaFile() {
      return this.$store.state.omniroom.groupMessageMediaFile.slice().reverse();
    },
    canEditContact() {
      return this.roomDetail.is_group == 0 && !!this.contactId;
    },
    displayPhoneNumber() {
      return (
        this.contactPhoneNumber ||
        this.getWhatsappNumberFromJid(this.roomDetail.room_number)
      );
    },
    activeAiRoom() {
      return this.getRoomById(this.activeRoomId) || this.roomDetail;
    },
    aiSessionHasId() {
      return !!(this.aiSession && this.aiSession.id);
    },
    aiSessionStatus() {
      if (!this.aiSession) {
        return "none";
      }
      if (Number(this.aiSession.is_destroy) === 1) {
        return "closed";
      }
      if (Number(this.aiSession.is_paused) === 1) {
        return "paused";
      }
      if (this.isAiSessionPreparingSummary()) {
        return "preparing";
      }
      return "running";
    },
    aiSessionBadgeLabel() {
      if (this.aiSessionStatus === "running") {
        return "Running";
      }
      if (this.aiSessionStatus === "paused") {
        return "Paused";
      }
      if (this.aiSessionStatus === "closed") {
        return "Closed";
      }
      if (this.aiSessionStatus === "preparing") {
        return "Menyiapkan";
      }
      return "";
    },
    aiSessionBadgeClass() {
      return "is-" + this.aiSessionStatus;
    },
    aiSessionIcon() {
      if (this.aiSessionStatus === "paused") {
        return "fa fa-pause-circle";
      }
      if (this.aiSessionStatus === "closed") {
        return "fa fa-ban";
      }
      if (this.aiSessionStatus === "preparing") {
        return "fa fa-hourglass-half";
      }
      return "fa fa-android";
    },
    aiSessionTitle() {
      if (this.aiSessionStatus === "running") {
        return "AI sedang menangani";
      }
      if (this.aiSessionStatus === "paused") {
        return "AI sedang dijeda";
      }
      if (this.aiSessionStatus === "closed") {
        return "Tidak ada sesi AI aktif";
      }
      if (this.aiSessionStatus === "preparing") {
        return "Sesi sedang ditutup";
      }
      return "";
    },
    aiSessionDescription() {
      if (this.aiSessionStatus === "running") {
        return "AI sedang membalas percakapan pelanggan secara otomatis.";
      }
      if (this.aiSessionStatus === "paused") {
        return "AI tidak membalas otomatis sampai sesi diaktifkan kembali.";
      }
      if (this.aiSessionStatus === "closed") {
        return "Sesi AI terakhir sudah ditutup. AI tidak membalas otomatis.";
      }
      if (this.aiSessionStatus === "preparing") {
        return "Sistem sedang menyiapkan rangkuman percakapan.";
      }
      return "";
    },
    aiSessionMeta() {
      if (!this.aiSession) {
        return "";
      }
      const timestamp = this.aiSessionSortValue(this.aiSession);
      if (!timestamp) {
        return "";
      }
      return "Sesi terbaru · " + moment.unix(timestamp).format("DD MMM YYYY, HH:mm");
    }
  },
  methods: {
    replaceName(name) {
      return name.replace(" ", "_");
    },
    getExt(filename) {
      const clean = String(filename || "").split("?")[0].split("#")[0];
      return clean.indexOf(".") === -1 ? "" : clean.split(".").pop();
    },
    fileNameFromUrl(value) {
      const url = String(value || "");
      if (!url || url.indexOf("data:") === 0) {
        return "Lampiran";
      }
      const clean = url.split("?")[0].split("#")[0];
      const name = clean.split("/").pop() || "Lampiran";
      try {
        return decodeURIComponent(name);
      } catch (error) {
        return name;
      }
    },
    downloadItem(url, label) {
      if (!url) {
        return;
      }

      axios({
        url: url,
        method: "GET",
        responseType: "blob" // important
      }).then(response => {
        const blob = new Blob([response.data]);
        const objectUrl = window.URL.createObjectURL(blob);
        if (!window.navigator.msSaveOrOpenBlob) {
          const link = document.createElement("a");
          link.href = objectUrl;
          link.setAttribute(
            "download",
            this.fileNameFromUrl(label) || "lampiran"
          );
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        } else {
          window.navigator.msSaveOrOpenBlob(blob, "lampiran");
        }
        window.setTimeout(() => window.URL.revokeObjectURL(objectUrl), 1000);
      });
    },
    getWhatsappNumberFromJid(jid) {
      return getWhatsappNumberFromJid(jid);
    },
    clickLightBox(message_media) {
      // console.log("message_media", message_media);
      this.$root.$emit("openGallery", message_media);
    },
    normalizeAiPhone(value) {
      return String(value || "")
        .split("@")[0]
        .replace(/\D/g, "");
    },
    normalizeTicketPhone(value) {
      return String(value || "")
        .split("@")[0]
        .split(":")[0]
        .replace(/\D/g, "");
    },
    currentTicketCustomerPhone() {
      const room = this.activeAiRoom || {};
      return this.normalizeTicketPhone(room.room_number);
    },
    currentAiCustomerPhone() {
      const room = this.activeAiRoom || {};
      return this.normalizeAiPhone(
        this.getWhatsappNumberFromJid(room.room_number)
      );
    },
    currentAiLicenseId() {
      return this.agentSession && this.agentSession.license_id
        ? String(this.agentSession.license_id)
        : "";
    },
    currentAiLicensePhone() {
      return this.agentSession && this.agentSession.license_phone_number
        ? this.normalizeAiPhone(this.agentSession.license_phone_number)
        : "";
    },
    ticketStatusLabel,
    ticketPriorityLabel,
    formatTicketDate,
    currentTicketContext() {
      const room = this.activeAiRoom || {};
      const licenseId = this.currentAiLicenseId();
      const contactNumber = this.currentTicketCustomerPhone();
      if (!this.activeRoomId || !licenseId || !contactNumber) {
        return null;
      }
      return {
        license_id: licenseId,
        license_phone_number:
          this.agentSession && this.agentSession.license_phone_number
            ? String(this.agentSession.license_phone_number)
            : "",
        license_name:
          this.agentSession && this.agentSession.license_name
            ? String(this.agentSession.license_name)
            : "",
        room_id: String(this.activeRoomId || ""),
        contact_number: contactNumber,
        contact_name: room.room_title || "",
        last_message: room.room_last_chat_message || "",
        default_agent_id:
          this.agentSession && this.agentSession.id
            ? String(this.agentSession.id)
            : ""
      };
    },
    resetTicketState(roomId) {
      this.ticketRequestId += 1;
      this.ticketLastRoomId = roomId ? String(roomId) : "";
      this.ticketRows = [];
      this.ticketError = "";
      this.ticketLoading = false;
      this.ticketRefreshing = false;
      this.showTicketModal = false;
      this.ticketContext = null;
    },
    scheduleTicketRefresh(delay, silent) {
      this.ticketRequestId += 1;
      this.ticketRefreshing = false;
      if (this.ticketRefreshTimer) {
        clearTimeout(this.ticketRefreshTimer);
      }
      const wait = typeof delay === "number" ? delay : 400;
      this.ticketRefreshTimer = setTimeout(() => {
        this.ticketRefreshTimer = null;
        this.refreshTickets({ silent: silent !== false });
      }, wait);
    },
    async refreshTickets(options) {
      const settings = options || {};
      const context = this.currentTicketContext();
      const roomId = String(this.activeRoomId || "");

      if (!context) {
        this.ticketRequestId += 1;
        this.ticketRows = [];
        this.ticketLoading = false;
        this.ticketRefreshing = false;
        return false;
      }
      if (
        settings.silent &&
        this.ticketRefreshing &&
        !settings.force
      ) {
        return false;
      }
      if (
        settings.silent &&
        this.$el &&
        this.$el.offsetParent === null &&
        !settings.force
      ) {
        return false;
      }

      const requestId = this.ticketRequestId + 1;
      this.ticketRequestId = requestId;
      this.ticketLoading = !this.ticketRows.length;
      this.ticketRefreshing = true;

      try {
        const response = await this.$store.dispatch("ticket/list", {
          license_id: context.license_id,
          contact_number: context.contact_number,
          page: 0,
          perPage: 20
        });

        if (requestId !== this.ticketRequestId) {
          return false;
        }
        if (String(this.activeRoomId || "") !== roomId) {
          return false;
        }
        if (this.currentAiLicenseId() !== context.license_id) {
          return false;
        }
        if (this.currentTicketCustomerPhone() !== context.contact_number) {
          return false;
        }

        const payload = response && response.data ? response.data : {};
        this.ticketRows = Array.isArray(payload.data) ? payload.data : [];
        this.ticketError = "";
        return true;
      } catch (error) {
        if (requestId !== this.ticketRequestId) {
          return false;
        }
        if (String(this.activeRoomId || "") !== roomId) {
          return false;
        }
        if (this.currentAiLicenseId() !== context.license_id) {
          return false;
        }
        this.ticketError = this.getAiSessionErrorMessage(
          error,
          "Daftar tiket belum dapat dimuat. Coba lagi."
        );
        return false;
      } finally {
        if (requestId === this.ticketRequestId) {
          this.ticketLoading = false;
          this.ticketRefreshing = false;
        }
      }
    },
    openTicketModal() {
      if (this.roomDetail.is_group == 1) {
        return;
      }
      const context = this.currentTicketContext();
      if (!context) {
        this.$fire({
          title: "Perhatian",
          text: "Konteks percakapan belum lengkap. Buka Chat Room yang valid terlebih dahulu.",
          type: "warning",
          timer: 3200
        });
        return;
      }
      this.ticketContext = context;
      this.showTicketModal = true;
    },
    handleTicketCreated(ticket, meta) {
      const attachmentsPending = !!(meta && meta.attachmentsPending)
      // Saat upload lampiran masih tertunda, modal tetap terbuka agar antrean
      // file dapat dicoba ulang tanpa membuat tiket duplikat.
      if (!attachmentsPending) {
        this.showTicketModal = false;
        this.$fire({
          title: "Berhasil",
          text:
            "Tiket " +
            (ticket && ticket.ticket_number ? ticket.ticket_number : "") +
            " berhasil dibuat.",
          type: "success",
          timer: 2600
        });
      }
      this.refreshTickets({ silent: false, force: true });
    },
    handleTicketAttachmentsUploaded(ticket, meta) {
      this.showTicketModal = false;
      const count = meta && meta.attachmentsUploaded ? meta.attachmentsUploaded : 0;
      this.$fire({
        title: "Berhasil",
        text:
          "Tiket " +
          (ticket && ticket.ticket_number ? ticket.ticket_number : "") +
          " berhasil dibuat" +
          (count ? " dengan " + count + " gambar lampiran." : "."),
        type: "success",
        timer: 3000
      });
      this.refreshTickets({ silent: false, force: true });
    },
    handleOpenTicketDetail(ticket) {
      this.showTicketModal = false;
      if (ticket && ticket.id) this.goTicketDetail(ticket);
    },
    goTicketDetail(ticket) {
      this.$router.push({
        name: "ticketDetail",
        params: { id: String(ticket.id) }
      });
    },
    startTicketPolling() {
      this.stopTicketPolling();
      this.ticketPollTimer = setInterval(() => {
        if (document.visibilityState !== "visible") {
          return;
        }
        if (!this.activeRoomId || this.roomDetail.is_group == 1) {
          return;
        }
        if (this.ticketLoading || this.ticketRefreshing) {
          return;
        }
        if (this.$el && this.$el.offsetParent === null) {
          return;
        }
        this.refreshTickets({ silent: true });
      }, 60000);
    },
    stopTicketPolling() {
      if (this.ticketPollTimer) {
        clearInterval(this.ticketPollTimer);
        this.ticketPollTimer = null;
      }
    },
    sessionMatchesAiLicense(session, licenseId, licensePhone) {
      if (!session) {
        return false;
      }
      const sessionLicenseId = session.license_id
        ? String(session.license_id)
        : "";
      const sessionLicensePhone = this.normalizeAiPhone(
        session.license_phone_number
      );

      if (licenseId) {
        if (sessionLicenseId) {
          return sessionLicenseId === licenseId;
        }
        return licensePhone
          ? sessionLicensePhone === licensePhone
          : false;
      }
      return licensePhone ? sessionLicensePhone === licensePhone : false;
    },
    aiSessionSortValue(session) {
      return (
        Number(session && session.create_datetime) ||
        Number(session && session.update_datetime) ||
        0
      );
    },
    compareAiSessions(first, second) {
      const firstTime = this.aiSessionSortValue(first);
      const secondTime = this.aiSessionSortValue(second);
      if (firstTime !== secondTime) {
        return secondTime - firstTime;
      }
      const firstId = Number(first && first.id);
      const secondId = Number(second && second.id);
      if (!isNaN(firstId) && !isNaN(secondId)) {
        return secondId - firstId;
      }
      return String((second && second.id) || "").localeCompare(
        String((first && first.id) || "")
      );
    },
    // Pilih sesi terbaru dari SELURUH status, bukan hanya Running/Paused.
    // Prioritas: lisensi + room_id, lalu lisensi + nomor pelanggan.
    pickLatestAiSession(rows, licenseId, licensePhone, roomId, customerPhone) {
      const list = Array.isArray(rows) ? rows : [];
      const licenseMatched = list.filter(session => {
        return this.sessionMatchesAiLicense(
          session,
          licenseId,
          licensePhone
        );
      });
      const roomMatched = licenseMatched.filter(session => {
        return (
          session &&
          session.room_id &&
          String(session.room_id) === String(roomId)
        );
      });
      const phoneMatched = licenseMatched.filter(session => {
        return (
          this.normalizeAiPhone(session && session.message_number) ===
          customerPhone
        );
      });
      const candidates = roomMatched.length ? roomMatched : phoneMatched;
      if (!candidates.length) {
        return null;
      }
      return candidates
        .slice()
        .sort((first, second) => this.compareAiSessions(first, second))[0];
    },
    isAiSessionPreparingSummary() {
      if (!this.aiSession) {
        return false;
      }
      const expire = Number(this.aiSession.expire_datetime);
      return expire > 0 && expire * 1000 < Date.now();
    },
    resetAiSessionState(roomId) {
      this.aiSessionRequestId += 1;
      this.aiSessionContextRoomId = roomId ? String(roomId) : "";
      this.aiSession = null;
      this.aiSessionError = "";
      this.aiSessionLoading = false;
      this.aiSessionRefreshing = false;
      this.aiSessionRoomId = "";
    },
    scheduleAiSessionRefresh(delay, silent) {
      // Setiap jadwal baru membatalkan respons lama agar status room
      // sebelumnya tidak menimpa room yang sedang aktif.
      this.aiSessionRequestId += 1;
      this.aiSessionRefreshing = false;
      if (this.aiRefreshTimer) {
        clearTimeout(this.aiRefreshTimer);
      }
      const wait = typeof delay === "number" ? delay : 400;
      this.aiRefreshTimer = setTimeout(() => {
        this.aiRefreshTimer = null;
        this.refreshAiSession({ silent: silent !== false });
      }, wait);
    },
    async refreshAiSession(options) {
      const settings = options || {};
      const roomId = String(this.activeRoomId || "");
      const room =
        this.getRoomById(this.activeRoomId) || this.roomDetail || {};
      const customerPhone = this.normalizeAiPhone(
        this.getWhatsappNumberFromJid(room.room_number)
      );
      const licenseId = this.currentAiLicenseId();
      const licensePhone = this.currentAiLicensePhone();

      if (!roomId || !customerPhone || (!licenseId && !licensePhone)) {
        this.aiSessionRequestId += 1;
        this.aiSession = null;
        this.aiSessionLoading = false;
        this.aiSessionRefreshing = false;
        return false;
      }

      if (
        settings.silent &&
        this.aiSessionRefreshing &&
        !settings.force
      ) {
        return false;
      }
      if (
        settings.silent &&
        this.$el &&
        this.$el.offsetParent === null &&
        !settings.force
      ) {
        return false;
      }

      const requestId = this.aiSessionRequestId + 1;
      this.aiSessionRequestId = requestId;
      this.aiSessionLoading = !this.aiSession;
      this.aiSessionRefreshing = true;

      try {
        const response = await this.$store.dispatch("aiKey/listSessions", {
          page: 0,
          perPage: 100,
          columnFilters: {
            message_number: customerPhone,
            is_destroy: "",
            is_paused: "",
            start_date: "",
            end_date: ""
          }
        });

        if (requestId !== this.aiSessionRequestId) {
          return false;
        }
        if (String(this.activeRoomId || "") !== roomId) {
          return false;
        }
        if (this.currentAiLicenseId() !== licenseId) {
          return false;
        }
        if (this.currentAiLicensePhone() !== licensePhone) {
          return false;
        }
        if (this.currentAiCustomerPhone() !== customerPhone) {
          return false;
        }

        const payload = response && response.data ? response.data : {};
        const rows = Array.isArray(payload.data) ? payload.data : [];
        this.aiSession = this.pickLatestAiSession(
          rows,
          licenseId,
          licensePhone,
          roomId,
          customerPhone
        );
        this.aiSessionRoomId = roomId;
        this.aiSessionError = "";
        return true;
      } catch (error) {
        if (requestId !== this.aiSessionRequestId) {
          return false;
        }
        if (String(this.activeRoomId || "") !== roomId) {
          return false;
        }
        if (this.currentAiLicenseId() !== licenseId) {
          return false;
        }
        this.aiSessionError = this.getAiSessionErrorMessage(
          error,
          "Status AI belum dapat dimuat. Coba lagi."
        );
        return false;
      } finally {
        if (requestId === this.aiSessionRequestId) {
          this.aiSessionLoading = false;
          this.aiSessionRefreshing = false;
        }
      }
    },
    getAiSessionErrorMessage(error, fallback) {
      const candidates = [
        error && error.message,
        error &&
          error.response &&
          error.response.data &&
          error.response.data.msg
      ];
      for (let index = 0; index < candidates.length; index++) {
        const value = candidates[index];
        if (
          typeof value === "string" &&
          value.trim() !== "" &&
          value !== "Error"
        ) {
          return value.replace(/<br\s*\/?>/gi, " ");
        }
      }
      return fallback;
    },
    async pauseAiSession() {
      if (
        this.aiSessionStatus !== "running" ||
        this.aiActionLoading ||
        !this.aiSessionHasId
      ) {
        return;
      }
      const confirmation = await this.$fire({
        title: "Jeda AI?",
        text:
          "AI tidak akan membalas otomatis sampai sesi diaktifkan kembali.",
        showCancelButton: true,
        confirmButtonText: "Ya, jeda AI",
        cancelButtonText: "Batal",
        type: "warning",
        confirmButtonColor: "#f39c12"
      });
      if (!confirmation || confirmation.value !== true) {
        return;
      }
      await this.runAiSessionAction(
        "aiKey/sessionPause",
        "AI berhasil dijeda."
      );
    },
    async resumeAiSession() {
      if (
        this.aiSessionStatus !== "paused" ||
        this.aiActionLoading ||
        !this.aiSessionHasId
      ) {
        return;
      }
      const confirmation = await this.$fire({
        title: "Aktifkan kembali AI?",
        text:
          "AI akan kembali membalas percakapan pelanggan secara otomatis.",
        showCancelButton: true,
        confirmButtonText: "Ya, aktifkan",
        cancelButtonText: "Batal",
        type: "warning",
        confirmButtonColor: "#f39c12"
      });
      if (!confirmation || confirmation.value !== true) {
        return;
      }
      await this.runAiSessionAction(
        "aiKey/sessionStart",
        "AI berhasil diaktifkan kembali."
      );
    },
    async runAiSessionAction(action, successText) {
      if (this.aiActionLoading) {
        return;
      }
      const session = this.aiSession;
      if (!session || !session.id) {
        return;
      }
      const targetRoomId = String(this.activeRoomId || "");
      const targetLicenseId = this.currentAiLicenseId();

      this.aiActionLoading = true;
      this.aiSessionError = "";
      try {
        await this.$store.dispatch(action, {
          id: [{ id: String(session.id) }]
        });

        // Jangan mengubah status secara optimistis. Ambil ulang dari backend
        // setelah aksi berhasil agar badge/tombol sesuai sumber kebenaran.
        this.aiSessionRequestId += 1;
        this.aiSessionRefreshing = false;
        const refreshed = await this.refreshAiSession({
          silent: true,
          force: true
        });
        const stillSameContext =
          String(this.activeRoomId || "") === targetRoomId &&
          this.currentAiLicenseId() === targetLicenseId;
        if (
          !refreshed &&
          !this.aiSessionError &&
          !this.aiSessionRefreshing &&
          stillSameContext
        ) {
          this.aiSessionError =
            "Aksi berhasil, tetapi status terbaru belum dapat dimuat. Status akan disinkronkan kembali.";
        }
        this.$fire({
          title: "Berhasil",
          text: successText,
          type: "success",
          timer: 2200
        });
      } catch (error) {
        this.$fire({
          title: "Operasi Gagal",
          text: this.getAiSessionErrorMessage(
            error,
            "Aksi AI belum berhasil. Coba lagi."
          ),
          type: "error"
        });
        this.aiSessionRequestId += 1;
        this.aiSessionRefreshing = false;
        await this.refreshAiSession({ silent: true, force: true });
      } finally {
        this.aiActionLoading = false;
      }
    },
    startAiSessionPolling() {
      this.stopAiSessionPolling();
      this.aiPollTimer = setInterval(() => {
        if (document.visibilityState !== "visible") {
          return;
        }
        if (!this.activeRoomId || this.roomDetail.is_group == 1) {
          return;
        }
        if (this.aiActionLoading || this.aiSessionRefreshing) {
          return;
        }
        if (this.$el && this.$el.offsetParent === null) {
          return;
        }
        this.refreshAiSession({ silent: true });
      }, 30000);
    },
    stopAiSessionPolling() {
      if (this.aiPollTimer) {
        clearInterval(this.aiPollTimer);
        this.aiPollTimer = null;
      }
    },
    handleAiVisibilityChange() {
      if (document.visibilityState === "visible") {
        this.scheduleAiSessionRefresh(0, false);
        this.scheduleTicketRefresh(0, false);
      }
    },
    handleAiPanelOpened() {
      this.scheduleAiSessionRefresh(0, false);
      this.scheduleTicketRefresh(0, false);
    },
    handleAiSessionRefreshRequested(payload) {
      if (
        payload &&
        payload.roomId &&
        String(payload.roomId) !== String(this.activeRoomId)
      ) {
        return;
      }
      if (payload && payload.roomNumber) {
        const expected = this.normalizeAiPhone(payload.roomNumber);
        const current = this.currentAiCustomerPhone();
        if (expected && current && expected !== current) {
          return;
        }
      }
      this.scheduleAiSessionRefresh(300, true);
    },
    handleSwitchRoom(roomArr) {
      const detail =
        this.$store.getters.getRoomById(roomArr.room_id) ||
        Object.assign({}, this.roomDetail, roomArr, {
          id: roomArr.room_id
        });

      this.roomDetail = detail;
      this.contactId = "";
      this.contactPhoneNumber =
        detail.is_group == 0
          ? this.getWhatsappNumberFromJid(detail.room_number)
          : "";
      this.phoneChangedInActiveRoom = false;
      this.showEditContact = false;
      this.editRoomId = "";

      const nextRoomId = String(roomArr.room_id || "");
      if (nextRoomId !== this.aiSessionContextRoomId) {
        this.resetAiSessionState(nextRoomId);
        this.scheduleAiSessionRefresh(0, false);
      } else if (
        !this.aiSession &&
        !this.aiSessionLoading &&
        !this.aiSessionRefreshing
      ) {
        this.scheduleAiSessionRefresh(100, true);
      }

      if (nextRoomId !== this.ticketLastRoomId) {
        this.resetTicketState(nextRoomId);
        this.scheduleTicketRefresh(0, false);
      } else if (
        !this.ticketRows.length &&
        !this.ticketLoading &&
        !this.ticketRefreshing
      ) {
        this.scheduleTicketRefresh(100, true);
      }
    },
    handleContactResolved(contactId) {
      this.contactId = contactId ? String(contactId) : "";
    },
    openEditContact() {
      if (!this.canEditContact) {
        return;
      }

      this.editRoomId = String(this.roomDetail.id || this.activeRoomId || "");
      this.showEditContact = true;
    },
    normalizePhoneDigits(value) {
      let digits = String(value || "").replace(/\D/g, "");
      if (digits.indexOf("0") === 0) {
        digits = "62" + digits.slice(1);
      }
      return digits;
    },
    handleContactSaved(payload) {
      this.showEditContact = false;

      const contact = payload && payload.contact ? payload.contact : {};
      const roomId = String(
        this.roomDetail.id || this.activeRoomId || this.editRoomId || ""
      );

      if (!this.editRoomId || roomId === this.editRoomId) {
        this.applyContactUpdateToActiveRoom(contact);
      }

      if (payload && payload.warning) {
        this.$fire({
          title: "Perhatian",
          text: payload.warning,
          type: "warning",
          timer: 3500
        });
        return;
      }

      this.$fire({
        title: "Berhasil",
        text: "Perubahan kontak berhasil disimpan.",
        type: "success",
        timer: 2500
      });
    },
    applyContactUpdateToActiveRoom(contact) {
      const firstName = contact.first_name || contact.FirstName || "";
      const lastName = contact.last_name || contact.LastName || "";
      const newTitle = (firstName + " " + lastName).trim();

      if (newTitle) {
        const roomId = this.roomDetail.id || this.activeRoomId;
        this.roomDetail = Object.assign({}, this.roomDetail, {
          room_title: newTitle
        });

        if (roomId) {
          const rooms = (this.$store.state.omniroom.roomListArr || []).map(
            room => {
              if (String(room.id) !== String(roomId)) {
                return room;
              }
              return Object.assign({}, room, { room_title: newTitle });
            }
          );
          this.$store.commit("omniroom/SET_roomListArr", rooms);
          this.$root.$emit("contactUpdated", {
            roomId: roomId,
            roomTitle: newTitle
          });
        }
      }

      const newPhone =
        contact.phone_number !== undefined && contact.phone_number !== null
          ? String(contact.phone_number)
          : "";

      if (newPhone) {
        this.contactPhoneNumber = newPhone;
        this.phoneChangedInActiveRoom =
          this.normalizePhoneDigits(newPhone) !==
          this.normalizePhoneDigits(
            this.getWhatsappNumberFromJid(this.roomDetail.room_number)
          );
      }

      if (this.$refs.tagsAssign && this.contactId) {
        this.$refs.tagsAssign.refreshContactById(this.contactId);
      }
    }
  },
  created() {
    this.$root.$on("switchRoom", this.handleSwitchRoom);
    this.$root.$on(
      "aiSessionRefreshRequested",
      this.handleAiSessionRefreshRequested
    );
    this.$root.$on("aiSessionPanelOpened", this.handleAiPanelOpened);
    document.addEventListener(
      "visibilitychange",
      this.handleAiVisibilityChange
    );
    this.startAiSessionPolling();
    this.startTicketPolling();
  },
  beforeDestroy() {
    this.$root.$off("switchRoom", this.handleSwitchRoom);
    this.$root.$off(
      "aiSessionRefreshRequested",
      this.handleAiSessionRefreshRequested
    );
    this.$root.$off("aiSessionPanelOpened", this.handleAiPanelOpened);
    document.removeEventListener(
      "visibilitychange",
      this.handleAiVisibilityChange
    );
    this.stopAiSessionPolling();
    this.stopTicketPolling();
    if (this.aiRefreshTimer) {
      clearTimeout(this.aiRefreshTimer);
      this.aiRefreshTimer = null;
    }
    if (this.ticketRefreshTimer) {
      clearTimeout(this.ticketRefreshTimer);
      this.ticketRefreshTimer = null;
    }
  }
};
</script>

<style>
.waajo-contact-panel {
  background: #ffffff;
  border-left: 1px solid #eef2f7;
}

.waajo-panel-inner {
  max-height: calc(100vh - 60px);
  padding: 20px 16px;
  overflow-y: auto;
}

.waajo-panel-head {
  padding-bottom: 16px;
  text-align: center;
  border-bottom: 1px solid #eef2f7;
}

.waajo-panel-avatar img {
  width: 84px;
  height: 84px;
  object-fit: cover;
  border: 3px solid #ffffff;
  border-radius: 22px;
  box-shadow: 0 8px 20px rgba(15, 23, 42, 0.12);
}

.waajo-panel-head h4 {
  margin: 10px 0 4px;
  color: #101828;
  font-size: 15px;
  font-weight: 700;
  line-height: 1.4;
  word-break: break-word;
}

.waajo-panel-actions {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 7px;
  padding: 12px 0;
  border-bottom: 1px solid #eef2f7;
}

.waajo-panel-action {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  min-height: 54px;
  padding: 8px 6px;
  color: #667085;
  background: #ffffff;
  border: 1px solid #e7edf5;
  border-radius: 10px;
  font-size: 9px;
  cursor: pointer;
}

.waajo-panel-action:hover {
  color: #b36b00;
  background: #fff7e8;
  border-color: #f6d49b;
}

.waajo-panel-action span {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  color: #b36b00;
  background: #fff7e8;
  border-radius: 7px;
  font-size: 11px;
}

.waajo-panel-action strong {
  font-size: 9px;
  font-weight: 700;
}

.waajo-panel-channel {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 3px 8px;
  color: #b36b00;
  background: #fff7e8;
  border: 1px solid #f6d49b;
  border-radius: 20px;
  font-size: 9px;
  font-weight: 600;
}

.waajo-panel-section {
  padding: 16px 0;
  border-bottom: 1px solid #eef2f7;
}

.waajo-panel-section:last-child {
  border-bottom: 0;
}

.waajo-panel-section h6 {
  margin: 0 0 9px;
  color: #101828;
  font-size: 11px;
  font-weight: 700;
}

.waajo-panel-section-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.waajo-panel-section-head h6 {
  margin-bottom: 9px;
}

.waajo-panel-section-head span {
  padding: 1px 7px;
  color: #b36b00;
  background: #fff7e8;
  border: 1px solid #f6d49b;
  border-radius: 20px;
  font-size: 9px;
  font-weight: 600;
}

.waajo-panel-row {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 10px;
  padding: 4px 0;
  font-size: 11px;
  line-height: 1.5;
}

.waajo-panel-row span {
  flex: 0 0 auto;
  color: #98a2b3;
}

.waajo-panel-row strong {
  color: #344054;
  font-weight: 600;
  text-align: right;
  word-break: break-word;
}

.waajo-panel-note {
  display: flex;
  align-items: flex-start;
  gap: 5px;
  margin: 6px 0 0;
  color: #b54708;
  font-size: 9px;
  line-height: 1.45;
}

.waajo-panel-note i {
  margin-top: 1px;
}

.waajo-panel-edit {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  width: 100%;
  min-height: 34px;
  margin-top: 10px;
  padding: 6px 10px;
  color: #b36b00;
  background: #fff7e8;
  border: 1px solid #f6d49b;
  border-radius: 8px;
  font-size: 10px;
  font-weight: 700;
  cursor: pointer;
}

.waajo-panel-edit:hover:not(:disabled) {
  color: #92400e;
  background: #ffefd5;
  border-color: #f2c078;
}

.waajo-panel-edit:disabled {
  color: #98a2b3;
  background: #f8fafc;
  border-color: #e7edf5;
  cursor: not-allowed;
}

.waajo-contact-panel .waajo-panel-section > .row {
  margin-right: 0;
  margin-left: 0;
}

.waajo-contact-panel .waajo-panel-section > .row > [class*="col-"] {
  padding-right: 0;
  padding-left: 0;
}

.waajo-contact-panel .multiselect {
  min-height: 34px;
  font-size: 10px;
}

.waajo-contact-panel .multiselect__tags {
  min-height: 36px;
  padding: 5px 32px 4px 8px;
  background: #f8fafc;
  border: 1px solid #e7edf5;
  border-radius: 8px;
}

.waajo-contact-panel .multiselect__tag {
  margin-right: 3px;
  margin-bottom: 3px;
  padding: 3px 20px 3px 7px;
  color: #b36b00;
  background: #fff7e8;
  border: 1px solid #f6d49b;
  border-radius: 20px;
  font-size: 9px;
}

.waajo-contact-panel .multiselect__tag-icon:after {
  color: #b36b00;
}

.waajo-contact-panel .multiselect__input,
.waajo-contact-panel .multiselect__single {
  margin-bottom: 0;
  font-size: 10px;
}

.waajo-contact-panel .multiselect__placeholder {
  padding-top: 3px;
  margin-bottom: 0;
  color: #98a2b3;
  font-size: 10px;
}

.waajo-contact-panel .multiselect__content-wrapper {
  border: 1px solid #e7edf5;
  border-radius: 8px;
  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.12);
}

.waajo-contact-panel .multiselect__option {
  padding: 7px 9px;
  font-size: 10px;
}

.waajo-contact-panel .multiselect__option--highlight {
  color: #b36b00;
  background: #fff7e8;
}

.waajo-file-list {
  padding: 0;
  margin: 0;
  list-style: none;
}

.waajo-file-list li {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 0;
  border-bottom: 1px dashed #eef2f7;
}

.waajo-file-list li:last-child {
  border-bottom: 0;
}

.waajo-file-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 34px;
  width: 34px;
  height: 34px;
  overflow: hidden;
  color: #b36b00;
  background: #fff7e8;
  border: 1px solid #f6d49b;
  border-radius: 8px;
  font-size: 13px;
  text-decoration: none;
}

.waajo-file-icon.is-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.waajo-file-info {
  flex: 1;
  min-width: 0;
}

.waajo-file-info strong {
  display: block;
  overflow: hidden;
  color: #344054;
  font-size: 10px;
  font-weight: 600;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.waajo-file-info small {
  display: block;
  color: #98a2b3;
  font-size: 9px;
}

.waajo-file-action {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 28px;
  width: 28px;
  height: 28px;
  padding: 0;
  color: #667085;
  background: #ffffff;
  border: 1px solid #e5eaf2;
  border-radius: 7px;
  font-size: 10px;
  cursor: pointer;
}

.waajo-file-action:hover {
  color: #b36b00;
  background: #fff7e8;
  border-color: #f6d49b;
}

.waajo-panel-empty {
  padding: 14px 0;
  color: #98a2b3;
  font-size: 10px;
  text-align: center;
}

/* ============================= AI CHAT SESSION ============================= */

.waajo-ai-session-section {
  padding: 14px 0;
}

.waajo-ai-session-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 9px;
}

.waajo-ai-session-head h6 {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin: 0;
  color: #101828;
  font-size: 12px;
  font-weight: 700;
}

.waajo-ai-session-head h6 i {
  color: #f39c12;
  font-size: 14px;
}

.waajo-ai-session-head-right {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.waajo-ai-session-refreshing {
  color: #f39c12;
  font-size: 11px;
}

.waajo-ai-session-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 3px 8px;
  border: 1px solid transparent;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 700;
  line-height: 1.4;
  white-space: nowrap;
}

.waajo-ai-session-badge.is-running {
  color: #067647;
  background: #ecfdf3;
  border-color: #bbf7d0;
}

.waajo-ai-session-badge.is-paused {
  color: #b54708;
  background: #fffaeb;
  border-color: #fedf89;
}

.waajo-ai-session-badge.is-closed {
  color: #b42318;
  background: #fff1f0;
  border-color: #fecdca;
}

.waajo-ai-session-badge.is-preparing {
  color: #475467;
  background: #f8fafc;
  border-color: #e2e8f2;
}

.waajo-ai-session-card {
  padding: 12px;
  background: #f8fafc;
  border: 1px solid #e7edf5;
  border-radius: 12px;
}

.waajo-ai-session-card.is-running {
  background: #f7fdf9;
  border-color: #d3f5e1;
}

.waajo-ai-session-card.is-paused {
  background: #fffcf5;
  border-color: #f6e3bd;
}

.waajo-ai-session-card.is-closed {
  background: #fff8f7;
  border-color: #f6d5d2;
}

.waajo-ai-session-card.is-preparing {
  background: #f8fafc;
  border-color: #e2e8f2;
}

.waajo-ai-session-state {
  display: flex;
  align-items: flex-start;
  gap: 10px;
}

.waajo-ai-session-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 34px;
  width: 34px;
  height: 34px;
  color: #b36b00;
  background: #fff7e8;
  border: 1px solid #f6d49b;
  border-radius: 10px;
  font-size: 15px;
}

.waajo-ai-session-card.is-running .waajo-ai-session-icon {
  color: #067647;
  background: #ecfdf3;
  border-color: #bbf7d0;
}

.waajo-ai-session-card.is-paused .waajo-ai-session-icon {
  color: #b54708;
  background: #fffaeb;
  border-color: #fedf89;
}

.waajo-ai-session-card.is-closed .waajo-ai-session-icon {
  color: #b42318;
  background: #fff1f0;
  border-color: #fecdca;
}

.waajo-ai-session-copy {
  min-width: 0;
}

.waajo-ai-session-copy strong {
  display: block;
  color: #101828;
  font-size: 13px;
  font-weight: 700;
  line-height: 1.4;
}

.waajo-ai-session-copy p {
  margin: 3px 0 0;
  color: #667085;
  font-size: 12px;
  line-height: 1.5;
}

.waajo-ai-session-action {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  width: 100%;
  height: 38px;
  margin-top: 12px;
  padding: 0 12px;
  border-radius: 9px;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  transition: background-color 0.18s ease, border-color 0.18s ease,
    color 0.18s ease;
}

.waajo-ai-session-action.is-pause {
  color: #b54708;
  background: #fffaeb;
  border: 1px solid #fedf89;
}

.waajo-ai-session-action.is-pause:hover:not(:disabled) {
  color: #93370d;
  background: #fff3d6;
  border-color: #f6c26b;
}

.waajo-ai-session-action.is-resume {
  color: #ffffff;
  background: #f39c12;
  border: 1px solid #f39c12;
  box-shadow: 0 3px 8px rgba(243, 156, 18, 0.18);
}

.waajo-ai-session-action.is-resume:hover:not(:disabled) {
  color: #ffffff;
  background: #e08b13;
  border-color: #e08b13;
}

.waajo-ai-session-action:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.waajo-ai-session-error {
  display: flex;
  align-items: flex-start;
  gap: 7px;
  padding: 9px 10px;
  color: #b42318;
  background: #fff7f6;
  border: 1px solid #fecdca;
  border-radius: 8px;
  font-size: 12px;
  line-height: 1.5;
}

.waajo-ai-session-error i {
  margin-top: 2px;
}

.waajo-ai-session-error span {
  flex: 1;
  min-width: 0;
}

.waajo-ai-session-error button {
  flex: 0 0 auto;
  padding: 0;
  color: inherit;
  background: transparent;
  border: 0;
  font-size: 12px;
  font-weight: 700;
  text-decoration: underline;
  cursor: pointer;
}

.waajo-ai-session-error.is-inline {
  margin-top: 10px;
  padding: 7px 9px;
  font-size: 11px;
}

.waajo-ai-session-empty {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  padding: 12px 8px;
  color: #98a2b3;
  font-size: 12px;
  line-height: 1.5;
  text-align: center;
}

.waajo-ai-session-empty i {
  color: #f39c12;
  font-size: 14px;
}

.waajo-ai-session-meta {
  display: block;
  margin-top: 9px;
  color: #98a2b3;
  font-size: 11px;
  line-height: 1.4;
  text-align: center;
}

.waajo-ai-session-skeleton {
  display: block;
  background: linear-gradient(90deg, #eef2f7 25%, #f8fafc 37%, #eef2f7 63%);
  background-size: 400% 100%;
  border-radius: 6px;
  animation: waajo-ai-session-shimmer 1.4s ease infinite;
}

.waajo-ai-session-skeleton.is-line {
  width: 100%;
  height: 12px;
  margin-bottom: 8px;
}

.waajo-ai-session-skeleton.is-line.is-short {
  width: 68%;
}

.waajo-ai-session-skeleton.is-button {
  width: 100%;
  height: 34px;
  margin-top: 12px;
  border-radius: 9px;
}

@keyframes waajo-ai-session-shimmer {
  0% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0 50%;
  }
}

.waajo-ticket-section .waajo-ticket-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 10px;
}

.waajo-ticket-section .waajo-ticket-head h6 {
  margin: 0;
  font-size: 14px;
}

.waajo-ticket-section .waajo-ticket-head h6 i {
  margin-right: 6px;
  color: var(--waajo-brand);
}

.waajo-ticket-head-actions {
  display: inline-flex;
  align-items: center;
  gap: 7px;
}

.waajo-ticket-refreshing {
  color: var(--waajo-brand-ink);
  font-size: 12px;
}

.waajo-ticket-refresh-btn {
  border: 0;
  background: transparent;
  color: var(--waajo-text-faint);
  padding: 0;
  font-size: 12px;
}

.waajo-ticket-refresh-btn:disabled {
  opacity: 0.5;
}

.waajo-ticket-add-btn {
  border: 1px solid var(--waajo-brand-border);
  background: var(--waajo-brand-soft);
  color: var(--waajo-brand-ink);
  border-radius: 8px;
  padding: 5px 9px;
  font-size: 12px;
  font-weight: 700;
}

.waajo-ticket-add-btn:disabled {
  opacity: 0.6;
}

.waajo-ticket-card {
  padding: 12px;
  border: 1px solid var(--waajo-border);
  border-radius: 12px;
  background: #ffffff;
}

.waajo-ticket-list {
  display: flex;
  flex-direction: column;
  gap: 9px;
  max-height: 320px;
  overflow-y: auto;
  padding-right: 2px;
}

.waajo-ticket-item {
  padding: 11px 12px;
  border: 1px solid var(--waajo-border);
  border-radius: 10px;
  background: #ffffff;
}

.waajo-ticket-item-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 6px;
  margin-bottom: 6px;
}

.waajo-ticket-number {
  color: var(--waajo-brand-ink);
  font-size: 11.5px;
  font-weight: 700;
  letter-spacing: 0.02em;
}

.waajo-ticket-title {
  display: block;
  color: var(--waajo-text);
  font-size: 13.5px;
  font-weight: 600;
  line-height: 1.45;
  margin-bottom: 7px;
  word-break: break-word;
}

.waajo-ticket-meta {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
  margin-bottom: 8px;
}

.waajo-ticket-pic {
  color: var(--waajo-text-muted);
  font-size: 11.5px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.waajo-ticket-item-foot {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding-top: 7px;
  border-top: 1px solid #f0f3f8;
}

.waajo-ticket-item-foot small {
  color: var(--waajo-text-faint);
  font-size: 11.5px;
}

.waajo-ticket-detail-btn {
  border: 0;
  background: transparent;
  color: var(--waajo-brand-ink);
  font-size: 12px;
  font-weight: 700;
  padding: 0;
}

.waajo-ticket-badge {
  display: inline-flex;
  align-items: center;
  padding: 3px 7px;
  border: 1px solid transparent;
  border-radius: 999px;
  font-size: 11.5px;
  font-weight: 700;
  line-height: 1.4;
  white-space: nowrap;
}

.waajo-ticket-badge.is-status-open {
  background: var(--waajo-status-open-bg);
  color: var(--waajo-status-open-ink);
  border-color: var(--waajo-status-open-border);
}

.waajo-ticket-badge.is-status-in-progress {
  background: var(--waajo-status-progress-bg);
  color: var(--waajo-status-progress-ink);
  border-color: var(--waajo-status-progress-border);
}

.waajo-ticket-badge.is-status-resolved {
  background: var(--waajo-status-resolved-bg);
  color: var(--waajo-status-resolved-ink);
  border-color: var(--waajo-status-resolved-border);
}

.waajo-ticket-badge.is-priority-urgent {
  background: var(--waajo-priority-urgent-bg);
  color: var(--waajo-priority-urgent-ink);
  border-color: var(--waajo-priority-urgent-border);
}

.waajo-ticket-badge.is-priority-normal {
  background: var(--waajo-priority-normal-bg);
  color: var(--waajo-priority-normal-ink);
  border-color: var(--waajo-priority-normal-border);
}

.waajo-ticket-badge.is-priority-low {
  background: var(--waajo-priority-low-bg);
  color: var(--waajo-priority-low-ink);
  border-color: var(--waajo-priority-low-border);
}

.waajo-ticket-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 12px 4px 14px;
  color: var(--waajo-text-muted);
  font-size: 12px;
  line-height: 1.5;
  text-align: center;
}

.waajo-ticket-empty i {
  font-size: 24px;
  color: #cbd5e1;
}

.waajo-ticket-create-btn {
  width: 100%;
  border: 1px dashed var(--waajo-brand-border);
  background: var(--waajo-brand-soft-2);
  color: var(--waajo-brand-ink);
  border-radius: 8px;
  padding: 8px 10px;
  font-size: 12px;
  font-weight: 700;
  margin-top: 9px;
}

.waajo-ticket-error {
  display: flex;
  align-items: flex-start;
  gap: 6px;
  color: #b42318;
  font-size: 11px;
  line-height: 1.5;
}

.waajo-ticket-error i {
  margin-top: 1px;
}

.waajo-ticket-error button {
  border: 0;
  background: transparent;
  color: #b42318;
  font-size: 11px;
  font-weight: 700;
  padding: 0;
  text-decoration: underline;
}

.waajo-ticket-error.is-inline {
  margin-bottom: 8px;
}

.waajo-ticket-skeleton {
  display: block;
  width: 100%;
  height: 11px;
  margin-bottom: 8px;
  border-radius: 5px;
  background: linear-gradient(90deg, #f2f4f7 25%, #e4e7ec 50%, #f2f4f7 75%);
  background-size: 200% 100%;
  animation: waajo-ai-session-shimmer 1.4s ease infinite;
}

.waajo-ticket-skeleton.is-short {
  width: 66%;
}

.waajo-ticket-skeleton.is-button {
  height: 30px;
  margin-top: 4px;
  margin-bottom: 0;
  border-radius: 7px;
}
</style>


// WEBPACK FOOTER //
// src/views/omni/RightSidebar.vue